import { render, staticRenderFns } from "./JSelectDepartModal.vue?vue&type=template&id=fc5a1f1c&scoped=true"
import script from "./JSelectDepartModal.vue?vue&type=script&lang=js"
export * from "./JSelectDepartModal.vue?vue&type=script&lang=js"
import style0 from "./JSelectDepartModal.vue?vue&type=style&index=0&id=fc5a1f1c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc5a1f1c",
  null
  
)

export default component.exports